import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';


/**------------------------------------------------------
 * Click Outside Event
 * -------------------
 * This directive will detect outside click, by doing so
 * it is possible to check if the user clicks outside
 * of the current element.
 * > Source: https://stackoverflow.com/questions/40107008/detect-click-outside-angular-component
 * -------------------
 * Context Menu
 * > Clicks within the context menu are ignored by default,
 * > Set the "ignoreContextMenu" parameter to change behavior
 * -------------------
 * Example:
 * 	<div class="tag-input-block position-relative" (ngClickOutside)="closeDropdown($event)"></div>
 */
@Directive({
    selector: '[ngClickOutside]',
    standalone: false
})
export class NgClickOutsideDirective {

	@Input()  ignoreContextMenu		 : boolean = true;
	@Output() readonly ngClickOutside: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(
		private eRef: ElementRef
	) {}

	@HostListener('document:click', ['$event.target'])
	clickOut(element: HTMLElement): void {

		//0 - click on context menu are not counted
		const contextElem: Element = document.body.querySelectorAll('.context-menu')[0];
		if (contextElem && contextElem.contains(element)) {
			this.ngClickOutside.emit(false);
			return;
		}

		//1 - check if the click was inside
		if (this.eRef.nativeElement.contains(element)) {
			this.ngClickOutside.emit(false);
			return;
		}

		//2 - click was inside
		this.ngClickOutside.emit(true);
	}
}
